import ButtonsHeader from "@/app/components/common/ButtonsHeader";
import CustomImage from "@/app/components/common/Image";
import { footerBg3Style, profile } from "@/assets";
import ProfileEditForm from "@/app/components/profile/ProfileEditForm";
import ProfileEditSkeleton from "@/app/components/common/skeletons/ProfileEditSkeleton";
import { useGetUserProfileQuery } from "@/lib/api/apiSlice";
import { useShowInitialLoader } from "@/lib/hooks";

export default function ProfileEditPage() {
  const { data: user, isLoading, isError } = useGetUserProfileQuery();
  const showLoader = useShowInitialLoader(isLoading, user);

  if (showLoader) {
    return <ProfileEditSkeleton />;
  }

  if (isError || !user) {
    return <div>Unable to load profile</div>;
  }

  return (
    <>
      <ButtonsHeader heading="Profile" />
      <div className="flex items-center justify-center px-4 sm:px-6">
        <CustomImage
          src={profile}
          alt="Profile"
          className="object-cover rounded-full bg-[#D7EAF5] border-2 border-[#F2994A] m-1"
        />
      </div>
      <div
        className="mt-4 min-h-[calc(100vh-13.5rem)] rounded-t-3xl bg-white p-6 pb-10 sm:p-6 lg:mx-auto lg:max-w-2xl"
        style={footerBg3Style}
      >
        <ProfileEditForm user={user} />
      </div>
    </>
  );
}
